// src/shared-external/CommonHeader.js
import cl7 from "classnames";
import * as React13 from "react";

// src/style/colors-v2.js
var colorsV2 = {
  accent01_100: "#EF692F",
  grey30: "#DFE1E6",
  grey70: "#5E6C84",
  grey100: "#242C34",
  black100: "#242938",
  black80: "#505460",
  black60: "#7C7F88",
  black40: "#A7A9AF",
  black20: "#D3D4D7",
  black10: "#E9EAEB",
  black5: "#F4F4F5",
  blackShadow1: "rgba(0, 0, 0, 0.01)",
  blackShadow2: "rgba(0, 0, 0, 0.02)",
  blackShadow3: "rgba(0, 0, 0, 0.03)",
  blackShadow4: "rgba(0, 0, 0, 0.04)",
  blackShadow5: "rgba(0, 0, 0, 0.05)",
  blackShadow6: "rgba(0, 0, 0, 0.06)",
  blackShadow7: "rgba(0, 0, 0, 0.07)",
  white100: "#FFFFFF",
  white80: "rgba(255, 255, 255, 0.8)",
  white60: "rgba(255, 255, 255, 0.6)",
  white40: "rgba(255, 255, 255, 0.4)",
  white20: "rgba(255, 255, 255, 0.2)",
  white10: "rgba(255, 255, 255, 0.1)",
  white5: "rgba(255, 255, 255, 0.05)",
  gray120: "#6D7D8D",
  gray100: "#8F92A1",
  gray80: "#A5A8B4",
  gray60: "#BCBEC7",
  gray50: "#D5D7E1",
  gray40: "#D2D3D9",
  gray20: "#E9E9EC",
  gray10: "#F4F4F6",
  gray5: "#F9FAFA",
  lightGray100: "#F3F6F8",
  lightGray80: "#F5F8F9",
  lightGray60: "#F8FAFB",
  lightGray40: "#FAFBFC",
  lightGray20: "#FDFDFE",
  lightGray10: "#FEFEFE",
  lightGray5: "#FEFFFF",
  primary100: "#D14242",
  primary80: "#DA6868",
  primary60: "#E38E8E",
  primary40: "#EDB3B3",
  primary20: "#F6D9D9",
  primary10: "#FAECEC",
  primary5: "#FDF6F6",
  pink100: "#F8B6C3",
  pink80: "#F9C5CF",
  pink60: "#FBD3DB",
  pink40: "#FCE2E7",
  pink20: "#FEF0F3",
  pink10: "#FEF8F9",
  pink5: "#FFFBFC",
  yellow120: "#dd7800",
  yellow100: "#FF991F",
  yellow80: "#FFAD4C",
  yellow60: "#FFC279",
  yellow40: "#FFD6A5",
  yellow20: "#FFEBD2",
  yellow10: "#FFF5E9",
  yellow5: "#FFFAF4",
  purple100: "#5243AA",
  purple80: "#7569BB",
  purple60: "#978ECC",
  purple40: "#BAB4DD",
  purple20: "#D5CBF6",
  purple10: "#F1EDFC",
  purple5: "#F6F6FB",
  green120: "#329546",
  green100: "#358756",
  green80: "#5D9F78",
  green60: "#86B79A",
  green40: "#AECFBB",
  green20: "#D7E7DD",
  green10: "#EBF3EE",
  green5: "#F5F9F7",
  red100: "#DE350B",
  red80: "#E55D3C",
  red60: "#EB866D",
  red40: "#F2AE9D",
  red20: "#F8D7CE",
  red10: "#FCEBE7",
  red5: "#FDF5F3",
  blue180: "#0F2657",
  blue160: "#143171",
  blue140: "#1B4193",
  blue120: "#2250B4",
  blue100: "#2B61D4",
  blue80: "#5480DE",
  blue60: "#7D9FE8",
  blue40: "#A7BFF1",
  blue20: "#CAD8F7",
  blue10: "#EDF2FD",
  blue5: "#F6F8FE",
  neutral200: "#21262D",
  neutral180: "#313A44",
  neutral160: "#434E5B",
  neutral140: "#5A6877",
  neutral120: "#6D7D8D",
  neutral100: "#8594A3",
  neutral80: "#A1ADB9",
  neutral70: "#5E6C84",
  neutral60: "#B8C1CC",
  neutral50: "#D5D7E1",
  neutral40: "#D2D8DF",
  neutral20: "#E3E7ED",
  neutral10: "#F2F4F7",
  neutral5: "#F9FAFB",
  blackTransparent100: "#000000",
  blackTransparent90: "rgba(0, 0, 0, 0.90)",
  blackTransparent80: "rgba(0, 0, 0, 0.80)",
  blackTransparent70: "rgba(0, 0, 0, 0.70)",
  blackTransparent60: "rgba(0, 0, 0, 0.60)",
  blackTransparent50: "rgba(0, 0, 0, 0.50)",
  blackTransparent40: "rgba(0, 0, 0, 0.40)",
  blackTransparent30: "rgba(0, 0, 0, 0.30)",
  blackTransparent20: "rgba(0, 0, 0, 0.20)",
  blackTransparent10: "rgba(0, 0, 0, 0.10)",
  blackTransparent5: "rgba(0, 0, 0, 0.05)",
  paper: "#FFF9F1",
  paper10: "#FFF6EB",
  paper40: "#FCE1BF",
  paper60: "#F7CC9C",
  paper120: "#CC7926",
  paper160: "#965B19",
  paper180: "#8F5717",
  neutralPrimary: "#313A44",
  DS100: "#27A3CD",
  DS10: "#DCF5FE",
  CA100: "#E25328"
};

// src/shared-external/CommonHeader.js
import styled8 from "styled-components";

// src/utils/media-query/media-query.js
var fromWidth = (minWidth) => `(min-width: ${minWidth}px)`;

// src/utils/media-query/responsive.util.js
import * as React from "react";
var fromScreen = (minWidth) => `@media screen and ${fromWidth(minWidth)}`;

// src/shared/CourseLanding/icons/Close.js
import * as React2 from "react";
function Close(props) {
  return /* @__PURE__ */ React2.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    ...props
  }, /* @__PURE__ */ React2.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.226 4.811A1 1 0 004.81 6.225L10.586 12l-5.774 5.775a1 1 0 101.414 1.414L12 13.414l5.775 5.775a1 1 0 001.414-1.414L13.415 12l5.774-5.775a1 1 0 10-1.414-1.414L12 10.586 6.226 4.81z",
    fill: "currentColor"
  }));
}
var MemoClose = React2.memo(Close);
var Close_default = MemoClose;

// src/shared/Header/IconHamburger.js
import * as React3 from "react";
function IconHamburger(props) {
  return /* @__PURE__ */ React3.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    ...props
  }, /* @__PURE__ */ React3.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.667 5c0-.46.373-.833.833-.833h15a.833.833 0 010 1.666h-15A.833.833 0 011.667 5zm0 5.027c0-.46.373-.834.833-.834h15a.833.833 0 010 1.667h-15a.833.833 0 01-.833-.833zm0 5.027c0-.46.373-.834.833-.834h15a.833.833 0 110 1.667h-15a.833.833 0 01-.833-.833z",
    fill: "#242938"
  }));
}
var MemoIconHamburger = React3.memo(IconHamburger);
var IconHamburger_default = MemoIconHamburger;

// node_modules/@dolstaff/shared/es/icons/OutlineArrowChevronRight.js
import React5 from "react";

// node_modules/@dolstaff/shared/es/Icon/index.js
import React4 from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var getSize = (number) => `${number}px`;
var getStrokeWidth = (size) => {
  if (size >= 32) {
    return 2;
  }
  if (size >= 24) {
    return 1.5;
  }
  return 1.5;
};
var StyledSvg = (_ref) => {
  let {
    className,
    color,
    viewBox,
    dataTest,
    children,
    ariaHidden,
    ariaLabel
  } = _ref, props = _objectWithoutProperties(_ref, ["className", "color", "viewBox", "dataTest", "children", "ariaHidden", "ariaLabel"]);
  return React4.createElement("svg", _extends({}, props, {
    className,
    viewBox,
    "data-test": dataTest,
    preserveAspectRatio: "xMidYMid meet",
    "aria-hidden": ariaHidden ? "true" : void 0,
    "aria-label": ariaLabel,
    color
  }), children);
};
var StyledIcon = styled(StyledSvg).withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "sc-17nvvtn-0"
})(["width:", ";height:", ";flex-shrink:0;vertical-align:middle;fill:transparent;path{stroke-width:", "px;}"], ({
  width
}) => getSize(width), ({
  height
}) => getSize(height), ({
  size
}) => getStrokeWidth(size));
var Icon = (props) => {
  const {
    size = 24,
    width,
    height,
    color,
    customColor,
    className,
    children,
    viewBox,
    dataTest,
    ariaHidden,
    reverseOnRtl,
    ariaLabel
  } = props;
  return React4.createElement(StyledIcon, {
    viewBox,
    size,
    width,
    height: height || size,
    color,
    className,
    dataTest,
    customColor,
    ariaHidden,
    reverseOnRtl,
    ariaLabel
  }, children);
};
Icon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  customColor: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  viewBox: PropTypes.string,
  dataTest: PropTypes.string,
  ariaHidden: PropTypes.string,
  reverseOnRtl: PropTypes.string,
  ariaLabel: PropTypes.string
};
var Icon_default = Icon;

// node_modules/@dolstaff/shared/es/icons/OutlineArrowChevronRight.js
var OutlineArrowChevronRight = (props) => {
  const {
    color,
    size,
    width,
    height,
    customColor,
    className,
    dataTest,
    ariaHidden,
    ariaLabel,
    reverseOnRtl
  } = props;
  return React5.createElement(Icon_default, {
    viewBox: "0 0 24 24",
    size,
    width,
    height,
    color,
    customColor,
    className,
    dataTest,
    ariaHidden,
    reverseOnRtl,
    ariaLabel
  }, React5.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.586 12L9.293 7.707a1 1 0 011.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414-1.414L13.586 12z",
    clipRule: "evenodd"
  }));
};
var OutlineArrowChevronRight_default = OutlineArrowChevronRight;

// src/shared-external/DesktopMenuList.js
import cl3 from "classnames";
import * as React9 from "react";
import styled4 from "styled-components";

// src/utils/checkIfLinkOfCurrentPageIsActive.js
var checkIfLinkOfCurrentPageIsActive = (link, exact = false) => {
  if (link && typeof window !== "undefined" && window.location) {
    if (exact) {
      return window.location.pathname.replace(/\//g, "") === link.replace(/\//g, "");
    }
    return window.location.pathname.replace(/\//g, "").includes(link.replace(/\//g, ""));
  }
  return false;
};
var checkIfLinkOfCurrentPageIsActiveByPath = (path, link, exact = false) => {
  if (link) {
    if (exact) {
      return path.replace(/\//g, "") === link.replace(/\//g, "");
    }
    return path.replace(/\//g, "").includes(link.replace(/\//g, ""));
  }
  return false;
};

// src/shared-external/NavMenuItem.js
import cl2 from "classnames";
import * as React8 from "react";
import styled3, { css as css2 } from "styled-components";

// src/shared-external/Link.js
import * as React6 from "react";
var Link = ({ href, to, children, ...rest }) => {
  return /* @__PURE__ */ React6.createElement("a", {
    href: to || href,
    ...rest
  }, children);
};

// src/components/DesignSystemV2/Typography.js
import * as React7 from "react";
import PropTypes2 from "prop-types";
import cl from "classnames";
import styled2, { css } from "styled-components";

// src/utils/hooks/useDeviceQuery.hook.js
import { useMediaQuery } from "react-responsive";
var deviceBreakpoints2 = {
  smallMobile: "(max-width: 540px)",
  largeMobile: "(min-width: 541px) and (max-width: 767px)",
  mobile: "(max-width: 767px)",
  tablet: "(min-width: 768px) and (max-width: 1134px)",
  desktop: "(min-width: 1135px)",
  xs: "(min-width: 360px)",
  sm: "(min-width: 541px)",
  md: "(min-width: 768px)",
  lg: "(min-width: 1135px)"
};
var deviceBreakpoints3 = {
  sm: "(min-width: 375px)",
  md: "(min-width: 458px)",
  lg: "(min-width: 1144px)",
  mobile: "(max-width: 775px)",
  tablet: "(min-width: 776px) and (max-width: 1143px)",
  desktop: "(min-width: 1144px)"
};

// src/components/DesignSystemV2/Typography.js
var DEFAULT_LINE_HEIGHT_MAP = {
  64: 72,
  56: 64,
  48: 56,
  44: 48,
  32: 40,
  24: 32,
  20: 28,
  18: 24,
  16: 24,
  15: 20,
  14: 20,
  13: 20,
  12: 16,
  10: 16
};
var VARIANT_FONT_WEIGHT_MAPPING = {
  regular: 400,
  medium: 500,
  "semi-bold": 600,
  bold: 700,
  black: 900
};
var DEFAULT_VARIANT = "regular/14";
var Typography = React7.memo((props) => {
  const {
    variant = DEFAULT_VARIANT,
    desktopVariant,
    tabletVariant,
    type = "p",
    v2 = false,
    v3 = false,
    className,
    ...rest
  } = props;
  let Component = Text;
  const parsedVariant = parseVariant(variant);
  const parsedTabletVariant = tabletVariant ? parseVariant(tabletVariant) : parsedVariant;
  const parsedDesktopVariant = desktopVariant ? parseVariant(desktopVariant) : parsedTabletVariant;
  switch (type) {
    case "p":
      Component = Text;
      break;
    case "span":
      Component = Span;
      break;
    default:
      Component = Text;
  }
  return /* @__PURE__ */ React7.createElement(Component, {
    breakPointV2: v2,
    breakPointV3: v3,
    className: cl("typography", className),
    variant: parsedVariant,
    tabletVariant: parsedTabletVariant,
    desktopVariant: parsedDesktopVariant,
    ...rest
  });
});
Typography.propTypes = {
  type: PropTypes2.oneOf(["span", "p"]),
  variant: PropTypes2.string.isRequired,
  style: PropTypes2.shape({}),
  desktopVariant: PropTypes2.string,
  tabletVariant: PropTypes2.string,
  v2: PropTypes2.bool
};
var parseVariant = (variant) => {
  const isIncludesLineHeight = /\d-\d/.test(variant);
  const [variantName, fontProperties] = variant.split("/");
  if (isIncludesLineHeight) {
    const [fontSize2, lineHeight] = fontProperties.split("-");
    return {
      fontSize: +fontSize2,
      lineHeight,
      fontWeight: VARIANT_FONT_WEIGHT_MAPPING[variantName]
    };
  }
  const fontSize = +fontProperties;
  return {
    fontSize,
    lineHeight: DEFAULT_LINE_HEIGHT_MAP[fontSize],
    fontWeight: VARIANT_FONT_WEIGHT_MAPPING[variantName]
  };
};
var Text = styled2.p`
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  color: ${(p) => p.color || colorsV2.black100};

  font-size: ${(p) => p.variant.fontSize}px;
  line-height: ${(p) => p.variant.lineHeight}px;
  font-weight: ${(p) => p.variant.fontWeight};

  @media ${(p) => p.breakPointV3 ? deviceBreakpoints3.md : deviceBreakpoints2.md} {
    ${(p) => p.tabletVariant && css`
        font-size: ${p.tabletVariant.fontSize}px;
        line-height: ${p.tabletVariant.lineHeight}px;
        font-weight: ${p.tabletVariant.fontWeight};
      `};
  }

  @media ${(p) => p.breakPointV3 ? deviceBreakpoints3.lg : deviceBreakpoints2.lg} {
    ${(p) => p.desktopVariant && css`
        font-size: ${p.desktopVariant.fontSize}px;
        line-height: ${p.desktopVariant.lineHeight}px;
        font-weight: ${p.desktopVariant.fontWeight};
      `};
  }
`;
var Span = styled2.span`
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: 0;
  margin-inline-end: 0;
  font-family: 'Inter', sans-serif;
  color: ${(p) => p.color || colorsV2.black100};

  font-size: ${(p) => p.variant.fontSize}px;
  line-height: ${(p) => p.variant.lineHeight}px;
  font-weight: ${(p) => p.variant.fontWeight};

  @media ${(p) => p.breakPointV3 ? deviceBreakpoints3.md : deviceBreakpoints2.md} {
    ${(p) => p.tabletVariant && css`
        font-size: ${p.tabletVariant.fontSize}px;
        line-height: ${p.tabletVariant.lineHeight}px;
        font-weight: ${p.tabletVariant.fontWeight};
      `};
  }

  @media ${(p) => p.breakPointV3 ? deviceBreakpoints3.lg : deviceBreakpoints2.lg} {
    ${(p) => p.desktopVariant && css`
        font-size: ${p.desktopVariant.fontSize}px;
        line-height: ${p.desktopVariant.lineHeight}px;
        font-weight: ${p.desktopVariant.fontWeight};
      `};
  }
`;

// src/shared-external/NavMenuItem.js
var underline = css2`
  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    right: 0;
    width: 0;
    height: 2px;
    background-color: ${colorsV2.black100};
    transition: 0.2s ease-out;
  }
`;
var LinkText = styled3.span`
  display: inline-block;
  position: relative;
  ${({ $isHeader }) => $isHeader && underline}
`;
var underlineHover = css2`
  &:hover {
    ${LinkText}::after {
      width: 100%;
      left: 0;
    }
  }
`;
var Main = styled3.div`
  position: relative;
  display: grid;
  align-items: center;
  gap: 8px;
  height: 100%;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  cursor: pointer;
  color: #242938;
  .menu-item {
    height: 100%;
    display: flex;
    align-items: center;

    &.header {
      ${underlineHover}
    }
  }
  .disabled {
    color: ${colorsV2.neutral80};
  }
  .tool-tip {
    display: none;
    position: absolute;
    padding: 8px 12px;
    width: 127px;
    right: -135px;
    z-index: 10000;
    background: ${colorsV2.neutral180};
    border-radius: 12px;
  }
  &:hover {
    .disabled {
      color: ${colorsV2.neutral120};
    }
    .tool-tip {
      display: block;
    }
  }
`;
var NavMenuItem = ({
  className,
  text,
  link,
  external,
  withIcon = false,
  isDisable = false,
  isHeader = false
}) => {
  if (external) {
    return /* @__PURE__ */ React8.createElement(Main, {
      className: cl2("nav-menu-item", {
        "empty-link": !link
      })
    }, link ? /* @__PURE__ */ React8.createElement("a", {
      key: text + link,
      href: `${link}`,
      target: "_blank",
      rel: "noopener noreferrer noffolow",
      className: cl2("menu-item", className, { header: isHeader })
    }, text, withIcon && /* @__PURE__ */ React8.createElement(OutlineArrowChevronRight_default, {
      width: 24,
      color: colorsV2.neutral100
    })) : /* @__PURE__ */ React8.createElement("div", {
      className: cl2("menu-item", className)
    }, text, withIcon && /* @__PURE__ */ React8.createElement(OutlineArrowChevronRight_default, {
      width: 24,
      color: colorsV2.neutral100
    })));
  }
  return /* @__PURE__ */ React8.createElement(Main, {
    className: cl2("nav-menu-item", { "empty-link": !link })
  }, link ? /* @__PURE__ */ React8.createElement(Link, {
    className: cl2(
      "menu-item",
      className,
      { disabled: isDisable },
      { header: isHeader }
    ),
    key: text + link,
    to: link
  }, /* @__PURE__ */ React8.createElement(LinkText, {
    $isHeader: isHeader
  }, text), withIcon && /* @__PURE__ */ React8.createElement(OutlineArrowChevronRight_default, {
    width: 24,
    color: colorsV2.neutral100
  }), isDisable && /* @__PURE__ */ React8.createElement("div", {
    className: "tool-tip"
  }, /* @__PURE__ */ React8.createElement(Typography, {
    variant: "medium/14-20",
    color: colorsV2.white100
  }, "Coming soon..."))) : /* @__PURE__ */ React8.createElement("div", {
    className: cl2("menu-item", className, { disabled: isDisable })
  }, /* @__PURE__ */ React8.createElement(LinkText, {
    $isHeader: isHeader
  }, text), withIcon && /* @__PURE__ */ React8.createElement(OutlineArrowChevronRight_default, {
    width: 24,
    color: colorsV2.neutral100
  }), isDisable && /* @__PURE__ */ React8.createElement("div", {
    className: "tool-tip"
  }, /* @__PURE__ */ React8.createElement(Typography, {
    variant: "medium/14-20",
    color: colorsV2.white100
  }, "Coming soon..."))));
};

// src/shared-external/DesktopMenuList.js
var Main2 = styled4.div`
  display: none;
  ${fromScreen(1260)} {
    display: grid;
  }
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  gap: 8px;
  height: 100%;
  align-items: center;
  justify-content: flex-end;

  .nav-list {
    border-bottom: 2px solid transparent;
    height: 100%;
    display: grid;
    place-items: center;
    cursor: pointer;
    a {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: ${colorsV2.black100};
    }
    &:hover,
    &.active {
      border-color: ${colorsV2.primary100};
      a {
        color: ${colorsV2.primary100};
      }
    }
  }

  .simple-groups-wrapper {
    display: none;
    position: fixed;
    top: 64px;
    padding-top: 8px;
    background-color: transparent;
    z-index: 60;
  }

  .sub-menu-groups-wrapper,
  .sub-menu-groups-wrapper-v3 {
    display: none;
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    box-shadow: rgb(0 0 0 / 4%) 0px 10px 20px, rgb(0 0 0 / 4%) 0px 2px 6px,
      rgb(0 0 0 / 4%) 0px 0px 1px;
    z-index: 60;
  }

  .sub-menu-group-items {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    max-width: 1366px;
    margin: 0 auto;
    gap: 24px;
    &.column-4-1 {
      grid-template-columns: 4fr 1fr;
    }
    &.column-3-2 {
      grid-template-columns: 3fr 2fr;
    }
  }

  .simple-group-items {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
    gap: 16px;
    padding: 32px;

    background-color: white;
    box-shadow: 0px 24px 32px rgba(0, 0, 0, 0.04),
      0px 16px 24px rgba(0, 0, 0, 0.04), 0px 4px 8px rgba(0, 0, 0, 0.04),
      0px 0px 1px rgba(0, 0, 0, 0.04);
    border-radius: 8px;

    .sub-menu-group {
      display: grid;
      grid-auto-rows: max-content;
      gap: 16px;
      > .sub-menu {
        a {
          font-weight: 700;
          text-transform: uppercase;
          font-size: 16px;
          line-height: 24px;
          &:hover {
            color: ${colorsV2.black100};
            cursor: auto;
          }
        }
      }
    }
  }

  .sub-menu-groups-wrapper {
    .sub-menu-group {
      padding: 40px 20px 40px 32px;
      display: grid;
      grid-auto-rows: max-content;
      gap: 24px 0;
      position: relative;
      &:last-child {
        padding: 40px 100px 40px 60px;
        &:before {
          z-index: -1;
          content: ' ';
          background: ${colorsV2.gray5};
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          bottom: 0;
          width: 100vw;
        }
      }
    }
    .sub-menu {
      .menu-item {
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        text-transform: uppercase;
      }
    }
  }

  .sub-menu-group-items-v3 {
    display: grid;
    grid-auto-columns: 1fr;
    max-width: 1366px;
    margin: 0 auto;
    &.column-3-2 {
      grid-template-columns: 3fr 2fr;
    }
  }

  .sub-menu-groups-wrapper-v3 {
    box-shadow: 0px 12px 24px 0px rgba(48, 66, 120, 0.08),
      0px 3px 6px 0px rgba(48, 66, 120, 0.06),
      0px 0px 1px 0px rgba(48, 66, 120, 0.06);
    .sub-menu-group {
      padding: 40px 20px 40px 32px;
      display: grid;
      grid-auto-rows: max-content;
      gap: 24px 0;
      position: relative;
      border-bottom: 1px solid ${colorsV2.neutral20};
    }
    .sub-menu {
      .menu-item {
        font-weight: 700;
        font-size: 20px;
        line-height: 28px;
        text-transform: uppercase;
      }
    }
    .sub-menu-group:nth-child(odd) {
      border-right: 1px solid ${colorsV2.neutral20};
    }
    .sub-menu-group:last-child,
    .sub-menu-group:nth-last-child(2) {
      border-bottom: none;
    }
  }

  .sub-menu-list-items {
    display: none;
    position: absolute;
    top: 64px;
    left: 0;

    z-index: 200;
    box-shadow: rgb(0 0 0 / 4%) 0px 10px 20px, rgb(0 0 0 / 4%) 0px 2px 6px,
      rgb(0 0 0 / 4%) 0px 0px 1px;
  }

  .sub-menu-groups {
    height: 100%;
    display: grid;
    place-items: center;
    border-bottom: 2px solid transparent;
    a {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: ${colorsV2.black100};
    }
    &:hover {
      border-color: ${colorsV2.primary100};
      a {
        color: ${colorsV2.black100};
      }
    }

    .group-wrapper {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: 1fr;
      margin: 0 auto;
      gap: 24px;
    }

    .group-items {
      display: grid;
      gap: 16px;

      padding-right: 24px;
      grid-auto-rows: max-content;
      justify-content: flex-start;
      &:last-child {
        padding-right: 0;
      }
    }

    .group-title {
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      text-transform: uppercase;
    }

    .group-title-v3 {
      font-size: 12px;
      line-height: 16px;
      font-weight: 700;
      text-transform: uppercase;
      color: ${colorsV2.neutral80};
    }

    .text-white {
      color: ${colorsV2.white100};
    }
    .group-list {
      display: grid;
      grid-auto-rows: max-content;
      gap: 12px;
      .menu-item {
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
      }
      a {
        color: ${colorsV2.black100};
        &:hover {
          color: ${colorsV2.primary100};
        }
      }
      .nav-menu-item.empty-link {
        a {
          color: ${colorsV2.black60};
          &:hover {
            color: ${colorsV2.black60};
          }
        }
      }
    }

    &.active {
      border-color: ${colorsV2.primary100};
      > .sub-menu {
        color: ${colorsV2.primary100};
        a {
          color: ${colorsV2.primary100};
        }
      }
    }
    &:hover {
      > .sub-menu {
        color: ${colorsV2.primary100};
        a {
          color: ${colorsV2.primary100};
        }
      }
      .simple-groups-wrapper {
        display: grid;
      }
      .sub-menu-groups-wrapper,
      .sub-menu-groups-wrapper-v3 {
        display: grid;
        background-color: ${colorsV2.white100};
      }
    }
  }

  .group-item.active {
    .nav-menu-item a {
      color: ${colorsV2.primary100};
    }
  }

  .sub-menu-list {
    height: 100%;
    display: grid;
    place-items: center;
    border-bottom: 2px solid transparent;
    position: relative;

    a {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: ${colorsV2.black100};
    }

    .group-wrapper {
      display: grid;
      width: 200px;
      grid-auto-flow: row;
      border-radius: 8px;
      padding: 8px 0px;
      background-color: rgb(255, 255, 255);
      box-shadow: 0 0 3px rgb(0 0 0 / 16%);
      border-radius: 5px;
    }

    .group-item {
      cursor: pointer;
      width: 100%;

      &:hover {
        background-color: rgb(244, 244, 246);
        box-shadow: none;
        border-bottom: none;
      }
      .nav-menu-item {
        a {
          padding: 12px 16px;
          width: 100%;
          font-weight: 400;
          font-size: 14px;
        }
      }
    }

    &:hover,
    &.active {
      .sub-menu {
        div {
          color: ${colorsV2.primary100};
        }
      }
      border-color: ${colorsV2.primary100};
    }
    &:hover {
      > .sub-menu {
        color: ${colorsV2.primary100};
        a {
          color: ${colorsV2.primary100};
        }
      }
      .sub-menu-list-items {
        display: block;
      }
    }
  }

  .sub-menu {
    height: 100%;
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-auto-columns: max-content;
    gap: 4px;
    .icon-arrow {
      transform: rotate(90deg);
    }
  }

  ${fromScreen(1144)} {
    gap: 24px;
  }
`;
var normalizeListItem = (item, newList = []) => {
  if (item) {
    if (item.link) {
      newList.push(item.link);
    }
    if (item.subMenu && item.subMenu.length > 0) {
      item.subMenu.forEach((sMenu) => normalizeListItem(sMenu, newList));
    }
  }
  return newList;
};
var calculateSimpleGroupWrapper = ({ elementRef }) => {
  const el = elementRef.current;
  if (el) {
    const position = el.getBoundingClientRect();
    if (position.width + position.x > window.innerWidth) {
      el.style.right = 0;
    }
  }
};
var SimpleGroupComponent = ({
  isActive,
  index,
  item,
  subMenu,
  renderMenuItem,
  renderItem
}) => {
  const ref = React9.useRef();
  return /* @__PURE__ */ React9.createElement("div", {
    key: index + item?.text,
    onMouseEnter: () => {
      calculateSimpleGroupWrapper({ elementRef: ref });
    },
    className: cl3("sub-menu-groups", {
      active: isActive
    })
  }, /* @__PURE__ */ React9.createElement("div", {
    className: "sub-menu"
  }, renderItem(item), /* @__PURE__ */ React9.createElement("div", {
    className: "icon-arrow"
  }, /* @__PURE__ */ React9.createElement(OutlineArrowChevronRight_default, {
    height: 12,
    width: 12
  }))), /* @__PURE__ */ React9.createElement("div", {
    ref,
    style: { width: item.width || "max-content" },
    className: "simple-groups-wrapper"
  }, /* @__PURE__ */ React9.createElement("div", {
    className: cl3("simple-group-items")
  }, subMenu.map((sMenu, sMenuIndex) => /* @__PURE__ */ React9.createElement(React9.Fragment, {
    key: sMenuIndex
  }, renderMenuItem(sMenu, sMenuIndex))))));
};
var DesktopMenuList = ({ data = [] }) => {
  const [currentPath, setCurrentPath] = React9.useState("");
  React9.useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);
  const renderItem = React9.useCallback((item, isHeader = false) => {
    return /* @__PURE__ */ React9.createElement(NavMenuItem, {
      key: item.text + item.link,
      text: item.text,
      link: item.link,
      external: item.external,
      withIcon: item.withIcon,
      isDisable: item.isDisable,
      isHeader
    });
  }, []);
  const renderMenuItem = React9.useCallback(
    (item, index) => {
      const { subMenu, type } = item;
      const isLinkActive = checkIfLinkOfCurrentPageIsActiveByPath(
        currentPath,
        item.link
      );
      if (subMenu && subMenu.length > 0) {
        switch (type) {
          case "simple-groups": {
            const isActive = subMenu.some((s) => {
              if (s?.subMenu?.length > 0) {
                return s.subMenu.some(
                  (g) => checkIfLinkOfCurrentPageIsActiveByPath(currentPath, g.link)
                );
              }
              return false;
            });
            return /* @__PURE__ */ React9.createElement(SimpleGroupComponent, {
              key: index + type,
              isActive,
              index,
              item,
              subMenu,
              renderMenuItem,
              renderItem
            });
          }
          case "simple-group": {
            return /* @__PURE__ */ React9.createElement("div", {
              key: index + type,
              className: "sub-menu-group"
            }, /* @__PURE__ */ React9.createElement("div", {
              className: "sub-menu"
            }, renderItem(item)), /* @__PURE__ */ React9.createElement("div", {
              className: "group-list"
            }, subMenu.map((group, gIndex) => {
              return /* @__PURE__ */ React9.createElement("div", {
                key: gIndex,
                className: cl3("group-item", {
                  active: checkIfLinkOfCurrentPageIsActiveByPath(
                    currentPath,
                    group.link
                  )
                })
              }, renderItem(group));
            })));
          }
          case "groups": {
            const columnNames = subMenu.map((n) => n.subMenu.filter((elm) => !elm.mobileOnly)?.length).join("-");
            const flattenList = normalizeListItem(item);
            const isActive = flattenList.some((itemLink) => {
              return checkIfLinkOfCurrentPageIsActiveByPath(
                currentPath,
                itemLink
              );
            });
            return /* @__PURE__ */ React9.createElement("div", {
              key: index + item?.text,
              className: cl3("sub-menu-groups", {
                active: isActive
              })
            }, /* @__PURE__ */ React9.createElement("div", {
              className: "sub-menu"
            }, renderItem(item), /* @__PURE__ */ React9.createElement("div", {
              className: "icon-arrow"
            }, /* @__PURE__ */ React9.createElement(OutlineArrowChevronRight_default, {
              width: 12
            }))), /* @__PURE__ */ React9.createElement("div", {
              className: "sub-menu-groups-wrapper"
            }, /* @__PURE__ */ React9.createElement("div", {
              className: cl3(
                "sub-menu-group-items",
                `column-${columnNames}`
              )
            }, subMenu.map((sMenu, sMenuIndex) => /* @__PURE__ */ React9.createElement(React9.Fragment, {
              key: sMenuIndex
            }, renderMenuItem(sMenu, sMenuIndex))))));
          }
          case "groups-v3": {
            const flattenList = normalizeListItem(item);
            const isActive = flattenList.some((itemLink) => {
              return checkIfLinkOfCurrentPageIsActiveByPath(
                currentPath,
                itemLink
              );
            });
            return /* @__PURE__ */ React9.createElement("div", {
              key: index + item?.text,
              className: cl3("sub-menu-groups", {
                active: isActive
              })
            }, /* @__PURE__ */ React9.createElement("div", {
              className: "sub-menu"
            }, renderItem(item), /* @__PURE__ */ React9.createElement("div", {
              className: "icon-arrow"
            }, /* @__PURE__ */ React9.createElement(OutlineArrowChevronRight_default, {
              width: 12
            }))), /* @__PURE__ */ React9.createElement("div", {
              className: "sub-menu-groups-wrapper-v3"
            }, /* @__PURE__ */ React9.createElement("div", {
              className: cl3("sub-menu-group-items-v3", "column-3-2")
            }, subMenu.map((sMenu, sMenuIndex) => {
              if (sMenu.mobileOnly)
                return;
              return /* @__PURE__ */ React9.createElement(React9.Fragment, {
                key: sMenuIndex
              }, renderMenuItem(sMenu, sMenuIndex));
            }))));
          }
          case "group": {
            return /* @__PURE__ */ React9.createElement("div", {
              className: "sub-menu-group",
              key: index + item?.text
            }, /* @__PURE__ */ React9.createElement("div", {
              className: "sub-menu"
            }, renderItem(item, true)), /* @__PURE__ */ React9.createElement("div", {
              className: "group-items"
            }, /* @__PURE__ */ React9.createElement("div", {
              className: "group-wrapper"
            }, subMenu.map((group, gIndex) => {
              if (group.mobileOnly)
                return;
              return /* @__PURE__ */ React9.createElement("div", {
                key: gIndex,
                className: "group-items"
              }, group.text && /* @__PURE__ */ React9.createElement("a", {
                href: group.link
              }, /* @__PURE__ */ React9.createElement("div", {
                className: cl3("group-title", {
                  "group-title-v3": group.v3,
                  "text-white": group.hide
                })
              }, group.text)), /* @__PURE__ */ React9.createElement("div", {
                className: "group-list"
              }, group.subMenu.map((subItem, subItemIndex) => {
                return /* @__PURE__ */ React9.createElement("div", {
                  key: subItemIndex,
                  className: cl3("group-item", {
                    active: checkIfLinkOfCurrentPageIsActiveByPath(
                      currentPath,
                      subItem.link,
                      true
                    )
                  })
                }, renderItem(subItem));
              })));
            }))));
          }
          default:
        }
        return /* @__PURE__ */ React9.createElement("div", {
          key: index + item?.text,
          className: cl3("sub-menu-list", {
            active: subMenu.some(
              (g) => checkIfLinkOfCurrentPageIsActiveByPath(currentPath, g.link)
            )
          })
        }, /* @__PURE__ */ React9.createElement("div", {
          className: "sub-menu"
        }, renderItem(item), /* @__PURE__ */ React9.createElement("div", {
          className: "icon-arrow"
        }, /* @__PURE__ */ React9.createElement(OutlineArrowChevronRight_default, {
          width: 12
        }))), /* @__PURE__ */ React9.createElement("div", {
          className: "sub-menu-list-items"
        }, /* @__PURE__ */ React9.createElement("div", {
          className: "group-wrapper"
        }, subMenu.map((group, gIndex) => {
          return /* @__PURE__ */ React9.createElement("div", {
            key: gIndex,
            className: cl3("group-item", {
              active: checkIfLinkOfCurrentPageIsActiveByPath(
                currentPath,
                group.link
              )
            })
          }, renderItem(group));
        }))));
      }
      return /* @__PURE__ */ React9.createElement("div", {
        key: index,
        className: cl3("nav-list", {
          active: isLinkActive
        })
      }, renderItem(item));
    },
    [currentPath, renderItem]
  );
  return /* @__PURE__ */ React9.createElement(Main2, {
    className: "desktop-menu-list"
  }, data.map((item, index) => {
    return /* @__PURE__ */ React9.createElement(React9.Fragment, {
      key: index
    }, renderMenuItem(item, index));
  }));
};

// src/shared-external/MobileBottomNav.js
import cl4 from "classnames";
import * as React10 from "react";
import styled5 from "styled-components";
var Main3 = styled5.div`
  display: grid;
  grid-auto-flow: column;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  grid-template-columns: max-content max-content max-content minmax(0, 1fr);
  background-color: white;
  z-index: 200;
  .button-navigation {
    padding: 12px 8px;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: ${colorsV2.black100};
    align-items: center;
    display: grid;
    place-items: center;
    border-top: 1px solid ${colorsV2.gray40};
    ${fromScreen(350)} {
      padding: 12px 16px;
    }
    &.active {
      background-color: ${colorsV2.primary10};
      color: ${colorsV2.primary100};
      border-top: 2px solid ${colorsV2.primary100};
    }
  }
  .button-navigation-hamburger {
    border-top: 1px solid ${colorsV2.gray40};
    display: grid;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 16px;
    > * {
      font-size: 20px;
      line-height: 0;
    }
  }
  ${fromScreen(1260)} {
    display: none;
  }
`;
var DEFAULT_MENU_LIST = [
  {
    id: 1,
    displayName: "Gi\xE1o vi\xEAn",
    to: "/linearteachers"
  },
  {
    id: 2,
    displayName: "\u0110i\u1EC3m & Review",
    to: "/hall-of-fame"
  },
  {
    id: 3,
    displayName: "Si\xEAu \u01B0u \u0111\xE3i",
    to: "/schedule"
  }
];
var MobileBottomNav = ({ data = DEFAULT_MENU_LIST, onToggleMenu }) => {
  return /* @__PURE__ */ React10.createElement(Main3, {
    className: "mobile-bottom-navigation"
  }, data.map(({ id, to, displayName }) => {
    return /* @__PURE__ */ React10.createElement(Link, {
      key: id,
      to
    }, /* @__PURE__ */ React10.createElement("div", {
      className: cl4("button-navigation", {
        active: checkIfLinkOfCurrentPageIsActive(to, to === "/")
      })
    }, displayName));
  }), /* @__PURE__ */ React10.createElement("div", {
    onClick: onToggleMenu,
    className: "button-navigation-hamburger"
  }, /* @__PURE__ */ React10.createElement(IconHamburger_default, null)));
};

// src/shared-external/MobileMenuList.js
import cl5 from "classnames";
import * as React11 from "react";
import styled6 from "styled-components";
var Main4 = styled6.div`
  padding-top: 32px;
  padding-bottom: 80px;
  display: grid;
  height: 100%;
  grid-auto-rows: max-content;
  gap: 8px;
  overflow: auto;
  scrollbar-gutter: stable;
  .nav-list {
    padding: 12px 10px 12px 20px;
    cursor: pointer;
    a {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      cursor: pointer;
      color: ${colorsV2.black100};
    }
    &:hover,
    &.active {
      background-color: rgb(244, 244, 246);
      box-shadow: none;
      border-bottom: none;
      color: ${colorsV2.primary100};
      a {
        color: ${colorsV2.primary100};
      }
    }
  }

  .group-wrapper {
    display: none;
    position: relative;
  }

  .group-vertical-line {
    width: 1px;
    height: 100%;
    background: ${colorsV2.gray20};
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: -1;
  }

  .sub-menu {
    display: grid;
    align-items: center;
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, 1fr) max-content;
    gap: 4px;
    padding: 12px 10px 12px 20px;
    cursor: pointer;
    .icon-arrow {
      transition: 0.2s ease;
      transform: rotate(90deg);
      color: ${colorsV2.black40};
    }

    &:hover,
    &.active {
      background-color: ${colorsV2.gray10};
      box-shadow: none;
      border-bottom: none;
      color: ${colorsV2.primary100};
      a {
        color: ${colorsV2.primary100};
      }
    }
  }

  .sub-menu-list {
    cursor: pointer;
    a {
      font-size: 14px;
      font-weight: 700;
      line-height: 20px;
      cursor: pointer;
      color: ${colorsV2.black100};
    }

    &.active {
      .sub-menu {
        div,
        a {
          color: ${colorsV2.primary100};
        }
      }
    }

    &.expanded {
      .group-wrapper {
        display: block;
      }
      .sub-menu {
        .icon-arrow {
          transform: rotate(270deg);
        }
      }
    }
  }

  .group-item {
    position: relative;
    margin-left: 20px;
    .nav-menu-item a {
      width: 100%;
      padding: 12px 20px 12px 12px;
      color: ${colorsV2.black100};
      font-weight: 500;
    }
    &.group-item-children {
      a {
        font-weight: 400;
      }
    }
    &.active,
    &:hover {
      > .nav-menu-item a {
        color: ${colorsV2.primary100};
      }
    }
  }

  ${fromScreen(1366)} {
    display: none;
  }
`;
var normalizeListItem2 = (list) => {
  const newList = [];
  list.forEach((item) => {
    if (item.type === "groups" || item.type === "groups-v3") {
      item.subMenu.forEach((ssMenu) => {
        if (!ssMenu.desktopOnly) {
          if (ssMenu.text) {
            newList.push(ssMenu);
          } else {
            newList.push({
              text: ssMenu.text,
              subMenu: ssMenu.subMenu
            });
          }
        }
      });
      return;
    }
    newList.push(item);
  });
  return newList;
};
var MobileMenuList = ({ data = [] }) => {
  const [openKeys, setOpenKeys] = React11.useState([]);
  const [currentPath, setCurrentPath] = React11.useState("");
  React11.useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);
  React11.useEffect(() => {
    const list = normalizeListItem2(data);
    list.forEach((item) => {
      const { subMenu } = item;
      if (subMenu?.length > 0) {
        const someLinkActive = subMenu.some(
          (g) => checkIfLinkOfCurrentPageIsActiveByPath(currentPath, g.link)
        );
        if (someLinkActive) {
          setOpenKeys(item.text);
        }
        subMenu?.forEach((k) => {
          const { subMenu: subMenu2 } = k;
          if (subMenu2?.length > 0) {
            const someLinkActive2 = subMenu2.some(
              (g) => checkIfLinkOfCurrentPageIsActiveByPath(currentPath, g.link)
            );
            if (someLinkActive2) {
              setOpenKeys(item.text);
            }
          }
        });
      }
    });
  }, [currentPath, data]);
  const renderItem = React11.useCallback((item) => {
    return /* @__PURE__ */ React11.createElement(NavMenuItem, {
      key: item.text + item.link,
      text: item.text,
      link: item.link,
      external: item.external
    });
  }, []);
  return /* @__PURE__ */ React11.createElement(Main4, {
    className: "mobile-menu-list"
  }, normalizeListItem2(data).map((item, index) => {
    const { text, link, subMenu } = item;
    const isLinkActive = checkIfLinkOfCurrentPageIsActiveByPath(
      currentPath,
      link
    );
    if (subMenu && subMenu.length > 0) {
      const someLinkActive = subMenu?.some?.(
        (g) => checkIfLinkOfCurrentPageIsActiveByPath(currentPath, g.link)
      );
      const someSubLinkActive = subMenu?.some?.(
        (g) => g.subMenu?.some((z) => {
          return checkIfLinkOfCurrentPageIsActiveByPath(
            currentPath,
            z.link
          );
        })
      );
      return /* @__PURE__ */ React11.createElement("div", {
        key: text,
        onClick: () => {
          setOpenKeys((o) => {
            if (o === text) {
              return [];
            }
            if (o.includes(text)) {
              return o.filter((item2) => item2 !== text);
            }
            return [...o, text];
          });
        },
        className: cl5("sub-menu-list", {
          expanded: openKeys.includes(text),
          active: isLinkActive || someLinkActive || someSubLinkActive
        })
      }, /* @__PURE__ */ React11.createElement("div", {
        className: "sub-menu"
      }, renderItem(item), /* @__PURE__ */ React11.createElement("div", {
        className: "icon-arrow"
      }, /* @__PURE__ */ React11.createElement(OutlineArrowChevronRight_default, {
        width: 24
      }))), /* @__PURE__ */ React11.createElement("div", {
        className: "sub-menu-list-items"
      }, /* @__PURE__ */ React11.createElement("div", {
        className: "group-wrapper"
      }, subMenu.map((group, gIndex) => {
        return /* @__PURE__ */ React11.createElement("div", {
          key: gIndex,
          className: cl5("group-item", {
            active: checkIfLinkOfCurrentPageIsActiveByPath(
              currentPath,
              group.link,
              true
            )
          })
        }, renderItem(group), group.subMenu?.length > 0 && /* @__PURE__ */ React11.createElement("div", {
          style: {
            marginTop: "12px"
          }
        }, group?.subMenu?.map((k, idx) => {
          return /* @__PURE__ */ React11.createElement("div", {
            key: idx,
            className: cl5(
              "group-item",
              "group-item-children",
              {
                active: checkIfLinkOfCurrentPageIsActiveByPath(
                  currentPath,
                  k.link,
                  true
                )
              }
            )
          }, /* @__PURE__ */ React11.createElement("div", {
            className: "group-vertical-line"
          }), renderItem(k));
        })));
      }))));
    }
    return /* @__PURE__ */ React11.createElement("div", {
      key: index,
      className: cl5("nav-list", {
        active: isLinkActive
      })
    }, renderItem(item));
  }));
};

// src/shared-external/MobileSideBar.js
import Portal from "@reach/portal";
import cl6 from "classnames";
import * as React12 from "react";
import styled7 from "styled-components";
var SIDE_BAR_WIDTH = 284;
var HEADER_HEIGHT = 64;
var MobileSidebarWrapper = styled7.div`
  .sidebar-drawer {
    position: fixed;
    left: 0;
    top: ${HEADER_HEIGHT}px;
    bottom: 0;
    z-index: 101;
    background-color: white;
    max-height: calc(100vh - ${HEADER_HEIGHT}px);
    width: ${SIDE_BAR_WIDTH}px;
    transition: all 0.2s ease;
    transform: translateX(-${SIDE_BAR_WIDTH}px);
    box-shadow: rgb(0 0 0 / 6%) 0px 8px 24px 0px;

    &.open {
      transform: translateX(0px);
    }
  }
  .sidebar-drawer-overlay {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
  }
  .header-bar {
    padding: 14px 32px;
    font-size: 38px;
    line-height: 0;
    width: ${SIDE_BAR_WIDTH}px;
  }

  ${fromScreen(1260)} {
    display: none;
  }
`;
var MobileSidebar = ({ children, open, onVisibleChange }) => {
  return /* @__PURE__ */ React12.createElement(Portal, null, /* @__PURE__ */ React12.createElement(MobileSidebarWrapper, null, /* @__PURE__ */ React12.createElement("div", {
    className: cl6("sidebar-drawer", {
      open
    })
  }, children), open && /* @__PURE__ */ React12.createElement("div", {
    onClick: () => onVisibleChange(false),
    className: "sidebar-drawer-overlay"
  })));
};

// src/shared-external/CommonHeader.js
var HEADER_HEIGHT2 = 64;
var HAMBURGER_BUTTON_WIDTH = 40;
var LOGO_DOL_WIDTH = 124;
var BTN_ACTION_WIDTH = 124;
var Main5 = styled8.header`
  font-family: 'Inter', sans-serif;
  top: 0;
  position: fixed;
  background-color: white;
  left: 0;
  right: 0;
  max-width: 100vw;
  min-height: ${HEADER_HEIGHT2}px;
  z-index: 104;
  display: grid;
  place-items: center;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.06);
  padding: 0 20px;

  .header-wrapper {
    display: grid;
    align-items: center;
    grid-gap: 16px;
    grid-template-columns: max-content ${LOGO_DOL_WIDTH}px minmax(0, 1fr);

    .logo-dol {
      display: block;
      line-height: 0;
      img {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }

    .cta-actions {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-right: 8px;
      .action-link {
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }
      }
      .btn-action {
        width: auto;
        background-color: ${colorsV2.primary100};
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        line-height: 24px;
      }
    }

    .btn-round-icon {
      width: ${HAMBURGER_BUTTON_WIDTH}px;
      min-width: ${HAMBURGER_BUTTON_WIDTH}px;
      height: ${HAMBURGER_BUTTON_WIDTH}px;
      min-height: ${HAMBURGER_BUTTON_WIDTH}px;
      background: ${colorsV2.gray10};
      border-radius: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      ${fromScreen(1260)} {
        display: none;
      }
    }

    width: calc(100vw - 32px);
    ${fromScreen(1260)} {
      grid-gap: 24px;
      height: 100%;
      grid-template-columns: ${LOGO_DOL_WIDTH}px minmax(0, 1fr) max-content;
      .cta-actions {
        .action-link {
          margin-right: 16px;
        }
        .btn-action {
          width: ${BTN_ACTION_WIDTH}px;
        }
      }
    }
    ${fromScreen(1366)} {
      width: 1302px;
      margin: 0 auto;
      padding: 0;
    }
  }

  ${fromScreen(1144)} {
    padding: 0;
  }
`;
var Wrapper = styled8.div``;
var CommonHeader = ({
  hideMobileSideBar,
  hideMobileBottomNav,
  menuData = [],
  logoUrl = "/",
  CTAButton = null
}) => {
  const [sidebarOpen, setSideBarOpen] = React13.useState(false);
  const mobileOnlyMenu = React13.useMemo(
    () => menuData.filter((item) => !item.desktopOnly),
    [menuData]
  );
  const desktopOnlyMenu = React13.useMemo(
    () => menuData.filter((item) => !item.mobileOnly),
    [menuData]
  );
  return /* @__PURE__ */ React13.createElement(Wrapper, {
    className: "header-root-wrapper"
  }, /* @__PURE__ */ React13.createElement(Main5, {
    className: cl7("header-root", {
      "without-sidebar": hideMobileSideBar
    }),
    id: "header-root"
  }, /* @__PURE__ */ React13.createElement("nav", {
    id: "navigation",
    className: "header-wrapper",
    role: "navigation"
  }, /* @__PURE__ */ React13.createElement("div", {
    onClick: () => setSideBarOpen((prevVisible) => !prevVisible),
    className: "btn-round-icon"
  }, sidebarOpen ? /* @__PURE__ */ React13.createElement(Close_default, null) : /* @__PURE__ */ React13.createElement(IconHamburger_default, null)), /* @__PURE__ */ React13.createElement(Link, {
    className: "logo-dol",
    to: logoUrl
  }, /* @__PURE__ */ React13.createElement("img", {
    src: "https://gqefcpylonobj.vcdn.cloud/directus-upload/cf52a50e-d2b9-47d6-a660-c499af14f9ff.png",
    alt: "Logo DOL English"
  })), /* @__PURE__ */ React13.createElement(DesktopMenuList, {
    data: desktopOnlyMenu
  }), CTAButton)), hideMobileSideBar ? null : /* @__PURE__ */ React13.createElement(MobileSidebar, {
    open: sidebarOpen,
    onVisibleChange: setSideBarOpen
  }, /* @__PURE__ */ React13.createElement(MobileMenuList, {
    data: mobileOnlyMenu
  })), hideMobileBottomNav ? null : /* @__PURE__ */ React13.createElement(MobileBottomNav, {
    onToggleMenu: () => setSideBarOpen((o) => !o)
  }));
};
export {
  CommonHeader
};
//# sourceMappingURL=CommonHeader.esm.js.map
